import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    innerContentWrapper:{
        padding:'0 20px 020px',
    },
    mainHeader:{
        backgroundImage: 'linear-gradient(#f2f4fd, #e8e9ef)',
        padding:'10px 0 10px 0',
        margin:'-22px 0 0 0',
    },
    headername:{
        float:'left',
        fontSize:'20px',
        margin:'0 0 0 20px',
        padding:'5px 0',
        textTransform:'uppercase'
    },
    btnWrapper:{
        right: '5px',
        position: 'absolute',
        "& .MuiButton-root":{
            borderRadius:'5px !important',
            fontSize: '12px',
            fontWeight: 'bold',

        },

    },
}));

export default useStyles
